import { LitElement as m, css as v, unsafeCSS as g, html as a, nothing as f } from "lit";
import { property as r } from "lit/decorators/property.js";
import { unsafeHTML as b } from "lit/directives/unsafe-html.js";
import { ifDefined as d } from "lit/directives/if-defined.js";
import y from "@smartdesign/image-tools";
const w = ':host{display:block;contain:strict;height:50px}:host([selected]){background-color:#d3e6fa}:host(:not([selected]):hover),:host(:not([selected])[focused]){background-color:#e7f1fa}@media (forced-colors: active){:host([selected]){outline:4px solid}:host(:not([selected]):hover){outline:4px dotted}:host(:not([selected])[focused]){outline:4px dashed}}:host([enable-line-clamp]) .labels>:only-child{display:-webkit-box;overflow:hidden;-webkit-line-clamp:2;-webkit-box-orient:vertical;white-space:normal;word-wrap:break-word}.container{display:flex;height:100%;box-sizing:border-box}.container .level-indicator{width:7px;height:100%}.container .level-indicator.level-0{background-color:#a0c3ef}.container .level-indicator.level-1{background-color:#e7c374}.container .level-indicator.level-2{background-color:#bfd596}.container .level-indicator.level-3{background-color:#fd998d}.container .level-indicator.level-4{background-color:#c6e8f5}.container .level-indicator.level-5{background-color:#fde3a4}.container .level-indicator.level-6{background-color:#dcbfe0}.side-content{display:flex;align-items:center;flex-grow:0}.labels{display:flex;flex-direction:column;justify-content:center;flex:1 1 0px;height:100%;line-height:normal;overflow:hidden;padding:var(--sd-list-item-label-content-padding, 0 8px)}.caption,.description{width:100%;font-family:var(--sd-list-item-font-family, "Segoe UI", "Lucida Sans", Arial, sans-serif);font-style:normal;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;-webkit-user-select:none;user-select:none;text-decoration:var(--sd-list-item-text-decoration, inherit)}.caption em,.description em{font-weight:bolder}.caption{font-size:var(--sd-list-item-caption-font-size, 16px);color:var(--sd-list-item-caption-text-color, #111);font-weight:var(--sd-list-item-caption-font-weight, normal)}.description{font-size:var(--sd-list-item-description-font-size, 13px);color:var(--sd-list-item-description-text-color, #767676);font-weight:var(--sd-list-item-description-font-weight, normal)}.icon-wrapper{width:var(--sd-list-item-icon-wrapper-width, 45px);height:100%;display:flex;align-items:center;justify-content:center}.icon-wrapper .icon{min-height:var(--sd-list-item-icon-size, 24px);min-width:var(--sd-list-item-icon-size, 24px);background-repeat:no-repeat;background-position:center;background-size:cover}';
var x = Object.defineProperty, k = Object.getOwnPropertyDescriptor, l = (i, t, e, o) => {
  for (var c = o > 1 ? void 0 : o ? k(t, e) : t, p = i.length - 1, h; p >= 0; p--)
    (h = i[p]) && (c = (o ? h(t, e, c) : h(c)) || c);
  return o && c && x(t, e, c), c;
}, s;
const n = (s = class extends m {
  constructor() {
    super(...arguments), this.contentMode = "text", this.role = "option";
  }
  static get styles() {
    return [
      v`
                ${g(w)}
            `
    ];
  }
  render() {
    return a`
            <div class="container">
                ${this.getLevelIndicators().map(
      (t, e) => a` <div class="level-indicator level-${e}"></div> `
    )}
                <div class="side-content">
                    <slot name="left-content"></slot>
                    ${this.renderIcon()}
                </div>
                <div class="labels">
                    ${this.renderLabel("caption", this.caption, this.captionAttrTitle)}
                    ${this.renderLabel("description", this.description, this.descriptionAttrTitle)}
                </div>
                <div class="side-content">
                    <slot name="right-content"></slot>
                </div>
            </div>
        `;
  }
  renderIcon() {
    if (this.icon || this.iconPlaceholder) {
      const t = this.iconBackgroundColor != null ? `background-color:${this.iconBackgroundColor}` : void 0;
      return a`
                <div
                    class="icon-wrapper"
                    @pointerdown="${this.handleIconClick}"
                    style="${d(t)}"
                    role="img"
                    aria-label="${d(this.iconAttrAriaLabel)}"
                    title="${d(this.iconAttrTitle)}"
                >
                    <div class="icon"></div>
                </div>
            `;
    }
    return f;
  }
  renderLabel(t, e, o) {
    return e ? a`
                  <div class="${t}" title="${d(o)}">
                      ${this.contentMode === "html" ? b(e) : e}
                  </div>
              ` : f;
  }
  updated(t) {
    super.updated(t), (t.has("icon") || t.has("iconPlaceholder")) && (this.icon || this.iconPlaceholder) && y.showImage(this.shadowRoot.querySelector(".icon"), this.icon, this.iconPlaceholder), t.has("selected") && this.setAttribute("aria-selected", String(this.selected));
  }
  /**
   * Returns the width in pixel which is missing to show the caption and description without ellipsis.
   */
  get missingWidthForTexts() {
    const t = this.enableLineClamp;
    this.removeAttribute("enable-line-clamp");
    let e = 0;
    const o = this.shadowRoot.querySelector(".caption");
    o && (e += o.scrollWidth - o.clientWidth);
    const c = this.shadowRoot.querySelector(".description");
    return c && (e = Math.max(e, c.scrollWidth - c.clientWidth)), e > 0 && e++, t && this.setAttribute("enable-line-clamp", ""), e;
  }
  handleIconClick(t) {
    !this.disabled && !this.dispatchEvent(new PointerEvent("list-item-icon-click", t)) && t.preventDefault();
  }
  getLevelIndicators() {
    return this.level ? Array(Number(this.level)).fill(null) : [];
  }
}, s.ID = "sd-list-item", s.ensureDefined = () => {
  customElements.get(s.ID) || customElements.define(s.ID, s);
}, s);
l([
  r({ type: String })
], n.prototype, "caption", 2);
l([
  r({ type: String })
], n.prototype, "description", 2);
l([
  r({ type: Boolean })
], n.prototype, "selected", 2);
l([
  r({ type: String })
], n.prototype, "icon", 2);
l([
  r({ type: String })
], n.prototype, "iconBackgroundColor", 2);
l([
  r({ type: String })
], n.prototype, "iconPlaceholder", 2);
l([
  r({ type: Number })
], n.prototype, "level", 2);
l([
  r()
], n.prototype, "contentMode", 2);
l([
  r({ type: Boolean, reflect: !0, attribute: "enable-line-clamp" })
], n.prototype, "enableLineClamp", 2);
l([
  r({ type: Boolean, reflect: !0, attribute: "aria-disabled" })
], n.prototype, "disabled", 2);
l([
  r({ type: String, attribute: "icon-attr-aria-label" })
], n.prototype, "iconAttrAriaLabel", 2);
l([
  r({ type: String, reflect: !0 })
], n.prototype, "role", 2);
l([
  r({ type: String, attribute: "caption-attr-title" })
], n.prototype, "captionAttrTitle", 2);
l([
  r({ type: String, attribute: "description-attr-title" })
], n.prototype, "descriptionAttrTitle", 2);
l([
  r({ type: String, attribute: "icon-attr-title" })
], n.prototype, "iconAttrTitle", 2);
let u = n;
const $ = (i, t) => {
  const e = document.createElement(u.ID);
  if (i) {
    if (e.caption = i.caption, e.description = i.description, e.icon = i.icon, e.iconBackgroundColor = i.iconBackgroundColor, e.iconPlaceholder = i.iconPlaceholder, e.level = i.level, e.disabled = i.disabled, i.contentMode && (e.contentMode = i.contentMode), i.leftContentGenerator) {
      const o = i.leftContentGenerator(i, e);
      o && (o.slot = "left-content", e.appendChild(o));
    }
    if (i.rightContentGenerator) {
      const o = i.rightContentGenerator(i, e);
      o && (o.slot = "right-content", e.appendChild(o));
    }
  }
  return e;
};
u.ensureDefined();
export {
  u as default,
  $ as generator
};
//# sourceMappingURL=list-item.mjs.map
